import { render, staticRenderFns } from "./FruitCanvas.vue?vue&type=template&id=019fe5bb&scoped=true&"
import script from "./FruitCanvas.vue?vue&type=script&lang=js&"
export * from "./FruitCanvas.vue?vue&type=script&lang=js&"
import style0 from "./FruitCanvas.vue?vue&type=style&index=0&id=019fe5bb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019fe5bb",
  null
  
)

export default component.exports